<template>
  <CrudForm
      :title="title"
      :labelSubmit="labelSubmit"
      :storeName="storeName"
      parentStoreName="coins_refunds"
      :submit="submit"
      :status="status"
      :canCancel="true"
      :canSubmit="false"
      :urlSendNotification="url_send_notification"
      :canUpdateDelete="false"
      :breadcrumbs="[
        {
          text: 'Finanzas',
          disabled: false,
          href: '/admin/coins_refunds'
        },
        {
          text: 'Historial de coins',
          disabled: false,
          href: '#'
        },
        {
          text: 'Detalle',
          disabled: true,
          href: '#'
        }
      ]"
  >
    <v-row justify="center" no-gutters>
      <v-col cols="8">

        <!-- Usuario -->
        <v-row no-gutters class="mt-4">
          <v-col class="py-0 px-2">
            <div class="label-base pb-1">Nombre</div>
            <v-text-field
                :value="data.user_id?.name"
                label="Usuario"
                solo
                hide-details="auto"
                class="input-base"
                disabled
            />
          </v-col>
          <v-col class="py-0 px-2">
            <div class="label-base pb-1">Apellidos</div>
            <v-text-field
                :value="data.user_id?.last_name"
                label="Email"
                solo
                hide-details="auto"
                class="input-base"
                disabled
            />
          </v-col>
        </v-row>

        <!-- Email -->
        <v-row no-gutters class="mt-2">
          <v-col class="py-0 px-2">
            <div class="label-base pb-1">Email</div>
            <v-text-field
                :value="data.user_id?.email"
                label="Email"
                solo
                hide-details="auto"
                class="input-base"
                disabled
            />
          </v-col>
        </v-row>

        <!-- Coins -->
        <v-row no-gutters class="mt-2">
          <v-col class="py-0 px-2">
            <div class="label-base pb-1">Total monedas</div>
            <v-text-field
                :value="data.user_id?.total_coins"
                label="Coins"
                solo
                hide-details="auto"
                class="input-base"
                disabled
            />
          </v-col>
          <v-col class="py-0 px-2">
            <div class="label-base pb-1">Monedas cargadas</div>
            <v-text-field
                v-model="data.coins"
                label="Coins"
                solo
                hide-details="auto"
                class="input-base"
                disabled
            />
          </v-col>
        </v-row>

        <!-- Comentarios -->
        <v-row no-gutters class="mt-2">
          <v-col class="py-0 px-2">
            <div class="label-base pb-1">Comentarios</div>
            <v-textarea
                v-model="data.comments"
                label="Comentarios"
                auto-grow
                rows="4"
                solo
                hide-details="auto"
                class="input-base"
                disabled
            />
          </v-col>
        </v-row>

        <!-- Fecha -->
        <v-row no-gutters class="mt-2">
          <v-col class="py-0 px-2">
            <div class="label-base pb-1">Fecha</div>
            <v-text-field
                :value="formatDate(data.createdAt)"
                label="Fecha"
                solo
                hide-details="auto"
                class="input-base"
                disabled
            />
          </v-col>
        </v-row>

      </v-col>
    </v-row>
  </CrudForm>
</template>

<script>
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapState } from "vuex";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { ValidationProvider, ValidationObserver, CrudForm },
  async created() {
    if (this.$route.params.id) {
      await this.$store
          .dispatch("Coins_refunds/show", this.$route.params.id)
          .then((val) => {
            this.data.user_id = val.user_id;
            this.data.user_enterprise_id = val.user_enterprise_id;
            this.data.coins = val.coins;
            this.data.comments = val.comments;
            this.data.createdAt = val.createdAt;
          });
    }
  },
  computed: {
    ...mapState({
      users: (state) => state.Users.list,
    }),
  },
  data() {
    return {
      storeName: "Coins_refunds",
      title: "Detalle de Coins Refund",
      data: {
        user_id: "",
        user_enterprise_id: "",
        coins: "",
        comments: "",
        createdAt: "",
      },
    };
  },
  methods: {
    formatDate(created_at) {
      if (!created_at) return null;
      let [date, time] = created_at.split("T");
      const [year, month, day] = date.split("-");
      time = (time.split(".")[0]);
      return `${day}/${month}/${year}`;
    },
  },
};
</script>
